module.exports = __webpack_public_path__ + "static/media/sunny.4c051c3a.svg";